module.exports = __webpack_public_path__ + "img/payment-paddle.78e3e4f6.svg";